import { FC } from 'react';

import Container from '@/components/elements/Container';
import Heading from '@/components/elements/Heading';

export interface LargeTextProps {
  text: any;
}

const LargeText: FC<LargeTextProps> = ({ text }) => {
  return (
    <Container size="full" gutter="none">
      <div className="not-prose relative w-full lg:flex lg:items-center">
        <Heading
          element="p"
          size="xl"
          color="dark"
          className="!max-w-none md:text-center"
        >
          {text}
        </Heading>
      </div>
    </Container>
  );
};

export default LargeText;
